import { Button, FormField, Icon } from '@chikara/ui';
import { SetupPasswordStepProps } from '@/features/onboarding/types/onboarding.types';
import { useOnboardingStep } from './useOnboardingStep';
import styles from '../Onboarding.module.css';
import { t } from '@/i18n';


export function SetupPasswordStep({ reference, onSuccess, onPasswordSet }: SetupPasswordStepProps) {
    const { state,
        error,
        isLengthValid,
        hasUppercase,
        hasNumber,
        hasSpecial,
        isFormValid,
        handleSetupPassword,
        handlePasswordChange,
        handleConfirmPasswordChange,
    } = useOnboardingStep({ onSuccess, reference, onPasswordSet });

    return (
        <form
            onSubmit={(e) => { e.preventDefault(); handleSetupPassword(); }}
            className={styles.formView}
        >
            <div className={styles.stepContainer}>
                <h2 className={styles.title}>{t('onboarding.setupPassword.title')}</h2>
                <p className={styles.subtitle}>{t('onboarding.setupPassword.subtitle')}</p>
            </div>

            <FormField
                label={t('onboarding.setupPassword.password')}
                type="password"
                value={state.password}
                onChange={handlePasswordChange}
                required
            />
    
            <FormField
                label={t('onboarding.setupPassword.confirmPassword')}
                type="password"
                value={state.confirmPassword}
                onChange={handleConfirmPasswordChange}
                required
            />

            <div className={styles.requirementsContainer}>
                <p className={styles.requirementsTitle}>{t('onboarding.passwordRequirements.title')}</p>
                <div className={styles.requirementsList}>
                    <div>
                        <Icon name={ isLengthValid ? "check" : "close"} size="sm" color={isLengthValid ? "success" : "error"} />
                        <span>{t('onboarding.passwordRequirements.length')}</span>
                    </div>
                    <div>
                        <Icon name={ hasUppercase ? "check" : "close"} size="sm" color={hasUppercase ? "success" : "error"} />
                        <span>{t('onboarding.passwordRequirements.uppercase')}</span>
                    </div>
                    <div>
                        <Icon name={ hasNumber ? "check" : "close"} size="sm" color={hasNumber ? "success" : "error"} />
                        <span>{t('onboarding.passwordRequirements.number')}</span>
                    </div>
                    <div>
                        <Icon name={ hasSpecial ? "check" : "close"} size="sm" color={hasSpecial ? "success" : "error"} />
                        <span>{t('onboarding.passwordRequirements.special')}</span>
                    </div>
                </div>
            </div>

            {error && <p className={styles.errorText}>{error}</p>}

            <Button type="submit" disabled={!isFormValid} className={styles.submitButton}>
                {t('onboarding.action')}
            </Button>
        </form>
    );
}
